// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-pane__table {
  border-collapse: collapse;
  background-color: white;
  min-width: 40rem;
  min-height: 13rem;
}

.schedule-pane__button {
  background-color: #eef;
  padding: var(--spacing-xs, 0.5rem);
  border: .5rem solid white;
  font-size: 100%;
}

.schedule-pane__button-icon {
  width: var(--icon-sm, 1.8rem);
  height: var(--icon-sm, 1.8rem);
}

.schedule-pane__nav {
  text-align: center;
  vertical-align: middle;
  padding-top: 4rem;
}

.schedule-pane__cell {
  padding: var(--spacing-xs, 0.3rem);
  text-align: center;
}

.schedule-pane__table .schedule-pane__form-heading {
  font-size: 110% !important;
  font-weight: bold;
  color: #888888;
  padding: 0.2em;
  margin: 0.7em 0 !important;
}

.schedule-pane__table .schedule-pane__form-heading--time-proposals {
  margin-bottom: 0 !important;
}

.schedule-pane__table .schedule-pane__panel--time-proposals {
  padding-bottom: 0.9rem !important;
  border: none !important;
}

.schedule-pane__table .schedule-pane__panel {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
  margin-right: 0.5rem;
  max-width: 100%;
  box-sizing: border-box;
}

@media (max-width: 1024px) {
  .schedule-pane__table .schedule-pane__main-cell {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    box-sizing: border-box;
  }

  .schedule-pane__table .schedule-pane__field-row--comment {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .schedule-pane__table .schedule-pane__field-row--comment > div:first-child {
    width: auto !important;
    min-width: 4.5rem;
    flex: 0 1 6rem;
  }

  .schedule-pane__table .schedule-pane__field-value--comment {
    min-width: 0;
    flex: 1 1 20rem;
    width: auto;
    padding-right: 0.25rem;
    box-sizing: border-box;
  }

  .schedule-pane__table .schedule-pane__field-value--comment .schedule-pane__form-control--textarea,
  .schedule-pane__table .schedule-pane__field-row--comment .schedule-pane__form-control--textarea {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
    margin: 0.2rem 0 0 !important;
    padding: 0.5rem 0.45rem;
  }
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__table {
  min-width: 0;
  width: 100%;
  min-height: 0;
  table-layout: fixed;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__table td,
div.schedule-pane[data-layout='mobile'] .schedule-pane__table th {
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__main-cell {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  box-sizing: border-box;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--compact {
  align-items: flex-start;
  gap: 0.25rem;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--compact .formFieldName {
  width: auto !important;
  min-width: 4.5rem;
  flex: 0 1 5.5rem;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--compact .formFieldValue {
  min-width: 0;
  flex: 1 1 auto;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--compact .schedule-pane__form-control {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  box-sizing: border-box;
  margin: 0.2rem 0 0 !important;
  font-size: var(--font-size-sm, 0.875rem);
  padding: 0.35rem 0.45rem;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--comment {
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch;
  gap: 0.25rem;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--comment .formFieldName,
div.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--comment > div:first-child {
  width: auto !important;
  min-width: 0;
  flex: 0 0 auto;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--comment .formFieldValue,
div.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--comment > div:last-child,
div.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-value--comment {
  min-width: 0;
  display: block;
  flex: 1 1 auto;
  width: 100%;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--comment .schedule-pane__form-control--textarea,
div.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-value--comment .schedule-pane__form-control--textarea {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  box-sizing: border-box;
  margin: 0 !important;
  font-size: var(--font-size-sm, 0.875rem);
  padding: 0.35rem 0.45rem;
  min-height: 5.5rem;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__button {
  padding: 0.4rem;
  border-width: 0.2rem;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__button-icon {
  width: 1.35rem;
  height: 1.35rem;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__nav {
  padding-top: 1rem;
}

div.schedule-pane[data-layout='mobile'] .schedule-pane__cell {
  padding: 0.2rem;
}

@media (max-width: 576px) {
  .schedule-pane__table {
    min-width: 0;
    width: 100%;
    min-height: 0;
    table-layout: fixed;
  }

  .schedule-pane__table td,
  .schedule-pane__table th {
    min-width: 0;
    max-width: 100%;
    overflow-wrap: anywhere;
  }

  .schedule-pane__table .schedule-pane__main-cell {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    box-sizing: border-box;
  }

  .schedule-pane__table .schedule-pane__field-row--compact {
    align-items: flex-start;
    gap: 0.25rem;
  }

  .schedule-pane__table .schedule-pane__field-row--compact .formFieldName {
    width: auto !important;
    min-width: 4.5rem;
    flex: 0 1 5.5rem;
  }

  .schedule-pane__table .schedule-pane__field-row--compact .formFieldValue {
    min-width: 0;
    flex: 1 1 auto;
  }

  .schedule-pane__table .schedule-pane__field-row--compact .schedule-pane__form-control {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
    margin: 0.2rem 0 0 !important;
    font-size: var(--font-size-sm, 0.875rem);
    padding: 0.35rem 0.45rem;
  }

  .schedule-pane__table .schedule-pane__field-row--comment {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch;
    gap: 0.25rem;
  }

  .schedule-pane__table .schedule-pane__field-row--comment .formFieldName,
  .schedule-pane__table .schedule-pane__field-row--comment > div:first-child {
    width: auto !important;
    min-width: 0;
    flex: 0 0 auto;
  }

  .schedule-pane__table .schedule-pane__field-row--comment .formFieldValue,
  .schedule-pane__table .schedule-pane__field-row--comment > div:last-child,
  .schedule-pane__table .schedule-pane__field-value--comment {
    min-width: 0;
    display: block;
    flex: 1 1 auto;
    width: 100%;
  }

  .schedule-pane__table .schedule-pane__field-row--comment .schedule-pane__form-control--textarea,
  .schedule-pane__table .schedule-pane__field-value--comment .schedule-pane__form-control--textarea {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
    margin: 0 !important;
    font-size: var(--font-size-sm, 0.875rem);
    padding: 0.35rem 0.45rem;
    min-height: 5.5rem;
  }

  .schedule-pane__button {
    padding: 0.4rem;
    border-width: 0.2rem;
  }

  .schedule-pane__button-icon {
    width: 1.35rem;
    height: 1.35rem;
  }

  .schedule-pane__nav {
    padding-top: 1rem;
  }

  .schedule-pane__cell {
    padding: 0.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/schedule/schedulePane.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,oBAAoB;EACpB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,eAAe;IACf,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,6BAA6B;IAC7B,uBAAuB;EACzB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;;;EAGE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,wCAAwC;EACxC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,6BAA6B;IAC7B,wCAAwC;IACxC,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;IACpB,YAAY;EACd;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;IACZ,cAAc;EAChB;;EAEA;;;IAGE,YAAY;IACZ,cAAc;IACd,cAAc;IACd,WAAW;EACb;;EAEA;;IAEE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,oBAAoB;IACpB,wCAAwC;IACxC,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".schedule-pane__table {\n  border-collapse: collapse;\n  background-color: white;\n  min-width: 40rem;\n  min-height: 13rem;\n}\n\n.schedule-pane__button {\n  background-color: #eef;\n  padding: var(--spacing-xs, 0.5rem);\n  border: .5rem solid white;\n  font-size: 100%;\n}\n\n.schedule-pane__button-icon {\n  width: var(--icon-sm, 1.8rem);\n  height: var(--icon-sm, 1.8rem);\n}\n\n.schedule-pane__nav {\n  text-align: center;\n  vertical-align: middle;\n  padding-top: 4rem;\n}\n\n.schedule-pane__cell {\n  padding: var(--spacing-xs, 0.3rem);\n  text-align: center;\n}\n\n.schedule-pane__table .schedule-pane__form-heading {\n  font-size: 110% !important;\n  font-weight: bold;\n  color: #888888;\n  padding: 0.2em;\n  margin: 0.7em 0 !important;\n}\n\n.schedule-pane__table .schedule-pane__form-heading--time-proposals {\n  margin-bottom: 0 !important;\n}\n\n.schedule-pane__table .schedule-pane__panel--time-proposals {\n  padding-bottom: 0.9rem !important;\n  border: none !important;\n}\n\n.schedule-pane__table .schedule-pane__panel {\n  padding-left: 0.75rem !important;\n  padding-right: 0.75rem !important;\n  margin-right: 0.5rem;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n@media (max-width: 1024px) {\n  .schedule-pane__table .schedule-pane__main-cell {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n    box-sizing: border-box;\n  }\n\n  .schedule-pane__table .schedule-pane__field-row--comment {\n    display: flex !important;\n    flex-direction: row !important;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .schedule-pane__table .schedule-pane__field-row--comment > div:first-child {\n    width: auto !important;\n    min-width: 4.5rem;\n    flex: 0 1 6rem;\n  }\n\n  .schedule-pane__table .schedule-pane__field-value--comment {\n    min-width: 0;\n    flex: 1 1 20rem;\n    width: auto;\n    padding-right: 0.25rem;\n    box-sizing: border-box;\n  }\n\n  .schedule-pane__table .schedule-pane__field-value--comment .schedule-pane__form-control--textarea,\n  .schedule-pane__table .schedule-pane__field-row--comment .schedule-pane__form-control--textarea {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0 !important;\n    box-sizing: border-box;\n    margin: 0.2rem 0 0 !important;\n    padding: 0.5rem 0.45rem;\n  }\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table {\n  min-width: 0;\n  width: 100%;\n  min-height: 0;\n  table-layout: fixed;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table td,\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table th {\n  min-width: 0;\n  max-width: 100%;\n  overflow-wrap: anywhere;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__main-cell {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  box-sizing: border-box;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--compact {\n  align-items: flex-start;\n  gap: 0.25rem;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--compact .formFieldName {\n  width: auto !important;\n  min-width: 4.5rem;\n  flex: 0 1 5.5rem;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--compact .formFieldValue {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--compact .schedule-pane__form-control {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  box-sizing: border-box;\n  margin: 0.2rem 0 0 !important;\n  font-size: var(--font-size-sm, 0.875rem);\n  padding: 0.35rem 0.45rem;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--comment {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: stretch;\n  gap: 0.25rem;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--comment .formFieldName,\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--comment > div:first-child {\n  width: auto !important;\n  min-width: 0;\n  flex: 0 0 auto;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--comment .formFieldValue,\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--comment > div:last-child,\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-value--comment {\n  min-width: 0;\n  display: block;\n  flex: 1 1 auto;\n  width: 100%;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-row--comment .schedule-pane__form-control--textarea,\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__table .schedule-pane__field-value--comment .schedule-pane__form-control--textarea {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  box-sizing: border-box;\n  margin: 0 !important;\n  font-size: var(--font-size-sm, 0.875rem);\n  padding: 0.35rem 0.45rem;\n  min-height: 5.5rem;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__button {\n  padding: 0.4rem;\n  border-width: 0.2rem;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__button-icon {\n  width: 1.35rem;\n  height: 1.35rem;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__nav {\n  padding-top: 1rem;\n}\n\ndiv.schedule-pane[data-layout='mobile'] .schedule-pane__cell {\n  padding: 0.2rem;\n}\n\n@media (max-width: 576px) {\n  .schedule-pane__table {\n    min-width: 0;\n    width: 100%;\n    min-height: 0;\n    table-layout: fixed;\n  }\n\n  .schedule-pane__table td,\n  .schedule-pane__table th {\n    min-width: 0;\n    max-width: 100%;\n    overflow-wrap: anywhere;\n  }\n\n  .schedule-pane__table .schedule-pane__main-cell {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n    box-sizing: border-box;\n  }\n\n  .schedule-pane__table .schedule-pane__field-row--compact {\n    align-items: flex-start;\n    gap: 0.25rem;\n  }\n\n  .schedule-pane__table .schedule-pane__field-row--compact .formFieldName {\n    width: auto !important;\n    min-width: 4.5rem;\n    flex: 0 1 5.5rem;\n  }\n\n  .schedule-pane__table .schedule-pane__field-row--compact .formFieldValue {\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  .schedule-pane__table .schedule-pane__field-row--compact .schedule-pane__form-control {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0 !important;\n    box-sizing: border-box;\n    margin: 0.2rem 0 0 !important;\n    font-size: var(--font-size-sm, 0.875rem);\n    padding: 0.35rem 0.45rem;\n  }\n\n  .schedule-pane__table .schedule-pane__field-row--comment {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: stretch;\n    gap: 0.25rem;\n  }\n\n  .schedule-pane__table .schedule-pane__field-row--comment .formFieldName,\n  .schedule-pane__table .schedule-pane__field-row--comment > div:first-child {\n    width: auto !important;\n    min-width: 0;\n    flex: 0 0 auto;\n  }\n\n  .schedule-pane__table .schedule-pane__field-row--comment .formFieldValue,\n  .schedule-pane__table .schedule-pane__field-row--comment > div:last-child,\n  .schedule-pane__table .schedule-pane__field-value--comment {\n    min-width: 0;\n    display: block;\n    flex: 1 1 auto;\n    width: 100%;\n  }\n\n  .schedule-pane__table .schedule-pane__field-row--comment .schedule-pane__form-control--textarea,\n  .schedule-pane__table .schedule-pane__field-value--comment .schedule-pane__form-control--textarea {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0 !important;\n    box-sizing: border-box;\n    margin: 0 !important;\n    font-size: var(--font-size-sm, 0.875rem);\n    padding: 0.35rem 0.45rem;\n    min-height: 5.5rem;\n  }\n\n  .schedule-pane__button {\n    padding: 0.4rem;\n    border-width: 0.2rem;\n  }\n\n  .schedule-pane__button-icon {\n    width: 1.35rem;\n    height: 1.35rem;\n  }\n\n  .schedule-pane__nav {\n    padding-top: 1rem;\n  }\n\n  .schedule-pane__cell {\n    padding: 0.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
